

document.querySelectorAll('.ApartmentItem').forEach(ApartmentItemInit)

function ApartmentItemInit(el) {
    if(!el.dataset.init) {
        el.dataset.init = '1';
        const slider = el.querySelector('.ApartmentItem__slider');
        new SliderControlMouse(slider, true);
    }
}
